import titlize from "./titlize.filter";

const titlizeModule = angular
  .module("app.filters.titlize", [])
  .filter("titlize", titlize);

export default titlizeModule;



// WEBPACK FOOTER //
// ./src/filters/titlize/titlize.module.js